var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 88,
    viewBox: "0 0 111 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4273 2.45961C22.464 9.98886 18.5135 17.5248 14.5395 25.0483C13.4068 27.1926 11.1712 33.7535 10.8944 31.3443C10.5191 28.0773 12.5151 23.5037 13.3621 20.4425C14.5574 16.1223 16.9913 7.4905 23.0562 7.52246C27.6342 7.54659 32.781 14.2603 33.4909 18.4485C33.9922 21.4059 35.4498 18.0663 37.4282 17.174",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7122 26.5809C41.3755 32.7747 45.3016 43.2461 53.3863 37.4852C57.1012 34.8381 55.2551 30.3079 51.5879 28.8692C42.6006 25.3435 31.276 35.1894 29.0347 43.2824C26.7938 51.3738 35.6399 53.8548 41.7251 54.6541C45.0923 55.0963 44.3371 52.2181 47.2344 51.2158",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0948 47.9972C54.1133 45.0817 44.8641 42.4828 40.9297 51.4048C39.0333 55.7052 47.5204 56.2095 50.0377 56.0911C54.8456 55.865 65.5515 44.7351 61.9445 47.9221C58.7793 50.7188 55.5759 54.0198 54.2744 58.15C53.4338 60.8175 54.3992 66.7114 57.4918 62.6411",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2444 53.5787C78.1113 54.5507 66.1021 55.0596 62.5071 66.4446C60.7398 72.0413 64.8861 75.9331 69.8822 77.5753C73.3735 78.7229 76.9324 76.2315 79.0505 73.7031",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4475 55.1233C96.892 55.7988 71.9312 83.004 83.8292 83.2143C87.1235 83.2725 90.5045 81.3558 92.7735 79.2007",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3054 60.073C81.0979 63.3784 85.823 66.8775 91.0798 69.4321C92.4451 70.0955 94.7203 70.4123 95.6601 71.788C96.1881 72.5609 95.358 70.7247 95.2656 70.4578",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.fa186eb9b60b7975f8b86200e3252503.svg";
export { ForwardRef as ReactComponent };